var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      ref: "sendCouponAdd",
      attrs: {
        title: "发放优惠券",
        visible: _vm.visible,
        "append-to-body": true,
        width: "68%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, size: "small", rules: _vm.rules },
        },
        [
          _c("el-form-item", { attrs: { label: "发放用户" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                },
              },
              [
                _c("el-input", {
                  staticStyle: { width: "30vw" },
                  attrs: {
                    disabled: _vm.fromPage === "user",
                    type: "textarea",
                    rows: 4,
                    placeholder:
                      "请输入电话号码用','分割，例如：138***88,139***99",
                  },
                  on: { change: _vm.onTextareaChange },
                  model: {
                    value: _vm.form.phonestr,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "phonestr", $$v)
                    },
                    expression: "form.phonestr",
                  },
                }),
                _vm.fromPage !== "user"
                  ? _c(
                      "span",
                      [
                        _c(
                          "el-upload",
                          {
                            ref: "fileUpload",
                            attrs: {
                              action: _vm.filePath,
                              "on-success": _vm.handleUpload,
                              multiple: "",
                              limit: 1,
                              headers: _vm.headers,
                              accept: ".xlsx, .xls",
                              data: { code: "activity" },
                              "file-list": _vm.userFileList,
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { size: "small", type: "primary" } },
                              [_vm._v("导入")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "el-upload__tip",
                                attrs: { slot: "tip" },
                                slot: "tip",
                              },
                              [_vm._v("只能上传xlsx/xls文件")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "el-upload__tip",
                                staticStyle: { color: "red" },
                                attrs: { slot: "tip" },
                                slot: "tip",
                              },
                              [
                                _vm._v(
                                  "\n              每次最多发送 10w 个用户\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.fromPage !== "user"
                  ? _c(
                      "span",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: { click: _vm.handleDown },
                          },
                          [_vm._v("下载模版")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "发券原因", prop: "remark" } },
            [
              _c("el-input", {
                staticStyle: { width: "30vw" },
                attrs: { type: "textarea", rows: 2 },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否发送到账通知", prop: "notic" } },
            [
              _c("el-switch", {
                attrs: { "active-color": "#13ce66" },
                model: {
                  value: _vm.form.notic,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "notic", $$v)
                  },
                  expression: "form.notic",
                },
              }),
            ],
            1
          ),
          _vm.form.notic
            ? _c(
                "el-form-item",
                { attrs: { label: "通知方式", prop: "noticList" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.noticList,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "noticList", $$v)
                        },
                        expression: "form.noticList",
                      },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { label: 1 },
                          on: { change: _vm.checkboxChange },
                        },
                        [_vm._v("发送短信")]
                      ),
                      _c("el-checkbox", { attrs: { label: 2 } }, [
                        _vm._v("发送小程序服务通知"),
                      ]),
                      _c("el-checkbox", { attrs: { label: 3 } }, [
                        _vm._v("乘客端展示优惠券到账弹窗"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showUpImgDom
            ? _c(
                "el-form-item",
                { attrs: { label: "通知弹窗", prop: "imgUrl" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "uploadRef",
                      class: { disabled: _vm.uploadDisabled },
                      staticStyle: { width: "100%" },
                      attrs: {
                        action: _vm.doUpload,
                        headers: _vm.headers,
                        name: "file",
                        "list-type": "picture-card",
                        "before-upload": function (file) {
                          return _vm.handleBeforeUpload(file, 640, 720)
                        },
                        "on-success": function (response, file, fileList) {
                          return _vm.uploadSuccess(response, file, fileList)
                        },
                        "on-error": _vm.handleUploadError,
                        "on-remove": _vm.handleRemove,
                        "file-list": _vm.fileList,
                        "show-file-list": true,
                        data: { code: "activity" },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [
                          _vm._v(
                            "\n          请上传大小不超过1MB,宽度640px，高度720px，格式为jpg/png\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("el-form-item", [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-circle-plus-outline",
                    },
                    on: { click: _vm.handleAddCoupon },
                  },
                  [_vm._v("\n          添加优惠券/礼包\n        ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "padding-top": "10px" } },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.couponItem,
                      border: "",
                      size: "mini",
                      "max-height": "280px",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "优惠券名称",
                        align: "center",
                        prop: "giftName",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    scope.row.type === 1
                                      ? scope.row.giftName
                                      : scope.row.name
                                  ) +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "优惠券类型",
                        align: "center",
                        prop: "type",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    scope.row.type === 1 ? "礼包" : "优惠券"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "优惠券金额",
                        align: "center",
                        prop: "discountsMoney",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "剩余数量",
                        align: "center",
                        prop: "surplusNum",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "发放数量",
                        align: "center",
                        prop: "num",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("avue-input-number", {
                                staticStyle: { width: "8vw" },
                                attrs: { "min-rows": "0" },
                                model: {
                                  value: scope.row.num,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "num", $$v)
                                  },
                                  expression: "scope.row.num",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deletes(scope.$index)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: { click: _vm.reset },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.sendLoading,
              },
              on: { click: _vm.handleSend },
            },
            [_vm._v("\n      发 放\n    ")]
          ),
          _c("span", [_vm._v("已选择： " + _vm._s(_vm.varMatch))]),
        ],
        1
      ),
      _vm.selectVisible
        ? _c("select-coupon", { ref: "selectCoupon" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }